import { EmailEntity } from '../entities/email-entity';

export default class State {
  loaded = false

  items: Array<EmailEntity> = [];
}
